/**
 * EVMDashboard — Mini EVM metrics grid for Civil Construction domain
 * Renders when evm object is present in agent response
 * Color-coded: green (good), amber (warning), red (critical)
 */
import React from 'react';

const getColor = (metric, value) => {
  const numVal = parseFloat(String(value).replace(/[^0-9.-]/g, ''));
  if (isNaN(numVal)) return 'bg-gray-50 text-gray-700 border-gray-200';

  if (metric === 'spi' || metric === 'cpi') {
    if (numVal >= 0.95) return 'bg-green-50 text-green-700 border-green-200';
    if (numVal >= 0.85) return 'bg-amber-50 text-amber-700 border-amber-200';
    return 'bg-red-50 text-red-700 border-red-200';
  }
  if (metric === 'sv' || metric === 'cv') {
    if (numVal >= 0) return 'bg-green-50 text-green-700 border-green-200';
    if (numVal >= -10) return 'bg-amber-50 text-amber-700 border-amber-200';
    return 'bg-red-50 text-red-700 border-red-200';
  }
  if (metric === 'completion') {
    const pct = parseFloat(String(value).replace('%', ''));
    if (pct >= 80) return 'bg-green-50 text-green-700 border-green-200';
    if (pct >= 50) return 'bg-amber-50 text-amber-700 border-amber-200';
    return 'bg-red-50 text-red-700 border-red-200';
  }
  return 'bg-blue-50 text-blue-700 border-blue-200';
};

const labels = {
  spi: 'SPI',
  cpi: 'CPI',
  eac: 'EAC',
  sv: 'Schedule Var.',
  cv: 'Cost Var.',
  completion: 'Completion'
};

const EVMDashboard = ({ evm }) => {
  if (!evm) return null;

  const metrics = ['spi', 'cpi', 'eac', 'sv', 'cv', 'completion'];

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3">
      <h4 className="text-xs font-semibold text-gray-500 uppercase mb-2 flex items-center gap-1">
        <span>📊</span> EVM Dashboard
      </h4>
      <div className="grid grid-cols-3 gap-2">
        {metrics.map(key => {
          const val = evm[key];
          if (val === undefined || val === null) return null;
          const colorClasses = getColor(key, val);
          return (
            <div key={key} className={`rounded-lg border p-2 text-center ${colorClasses}`}>
              <div className="text-xs font-medium opacity-70">{labels[key] || key.toUpperCase()}</div>
              <div className="text-lg font-bold">{val}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EVMDashboard;
